import aerrow from "../../assets/upload_file.svg"

const CircularProgress = ({ size, thickness, color, progress ,isIcon=true,BG_transparent=false}) => {
  const radius = (size - thickness) / 2
  const circumference = 2 * Math.PI * radius;

  const dashOffset = circumference - (progress / 100) * circumference
  return (
    <svg className="circular-progress" width={size} height={size} style={BG_transparent ? { backgroundColor: 'transparent' } : undefined}>
      <circle className="background"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={thickness}
      />
      <circle className="progress"
        cx={size / 2}
        cy={size / 2}
        r={radius}
        strokeWidth={thickness}
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        stroke={color}
      />
      {isIcon &&
      <image style={{width:15,height:15}} x="25%" y="22%" xlinkHref={aerrow} />
       }
    </svg>
  )
}

export default CircularProgress
